import { Container } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'
import Refer from '../../../components/referAndEarn/Refer'

const ReferAndEarnPage: React.FC = () => {
  return (
    <Container component="main" sx={{ flex: 1 }}>
      <Helmet>
        <title>Resactly | Refer & Earn</title>
      </Helmet>
      <Refer type="eater" />
    </Container>
  )
}

export default ReferAndEarnPage
